// ============================================================
//  ADMIN PRODUCTS v5 — with Preorder + Sold Out support
// ============================================================
(function() {
  'use strict';

  var SOLD_OUT_API = 'https://enotexcustompayment.vercel.app/api/sold-out';
  var LS_KEY = 'enotex_sold_out_ids';
  var LS_PREORDER_KEY = 'enotex_preorder_ids';
  var soldOutIds = [];
  var preorderIds = [];
  var activeCategory = 'all';
  var activeStatus = 'all';
  var searchQuery = '';

  function debugLog(msg) {
    console.log('[SoldOut] ' + msg);
  }

  document.addEventListener('DOMContentLoaded', function() {
    debugLog('INIT — admin-products.js v5 loaded (preorder support)');
    loadSoldOutState();
    setupSearch();
    setupCategoryFilter();
    setupStatusFilter();
    setupToggleButtons();
    setupBuilderSync();
  });

  // ============================================================
  //  PERSISTENCE — localStorage + Redis API
  // ============================================================
  function loadSoldOutState() {
    try {
      var stored = localStorage.getItem(LS_KEY);
      if (stored) {
        soldOutIds = JSON.parse(stored);
        debugLog('Loaded ' + soldOutIds.length + ' sold-out IDs from localStorage');
      }
      var storedPO = localStorage.getItem(LS_PREORDER_KEY);
      if (storedPO) {
        preorderIds = JSON.parse(storedPO);
        debugLog('Loaded ' + preorderIds.length + ' preorder IDs from localStorage');
      }
      applyAllStates();
    } catch(e) {
      debugLog('localStorage read error: ' + e.message);
    }
    fetchFromAPI();
  }

  async function fetchFromAPI() {
    try {
      var token = sessionStorage.getItem('admin_token');
      var res = await fetch(SOLD_OUT_API, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (token || '') }
      });
      var data = await res.json();
      debugLog('API GET response: ' + JSON.stringify(data));
      if (data.success) {
        if (Array.isArray(data.ids)) {
          soldOutIds = data.ids;
          localStorage.setItem(LS_KEY, JSON.stringify(soldOutIds));
        }
        if (Array.isArray(data.preorderIds)) {
          preorderIds = data.preorderIds;
          localStorage.setItem(LS_PREORDER_KEY, JSON.stringify(preorderIds));
        }
        applyAllStates();
        applyToBuilder();
      }
    } catch(e) {
      debugLog('API fetch error: ' + e.message);
    }
  }

  async function saveProductState(variantId, action) {
    // action: 'available', 'preorder', or 'sold-out'
    var vidStr = String(variantId);

    // Update local arrays
    soldOutIds = soldOutIds.filter(function(id) { return id !== vidStr; });
    preorderIds = preorderIds.filter(function(id) { return id !== vidStr; });

    if (action === 'sold-out') {
      soldOutIds.push(vidStr);
    } else if (action === 'preorder') {
      preorderIds.push(vidStr);
    }

    localStorage.setItem(LS_KEY, JSON.stringify(soldOutIds));
    localStorage.setItem(LS_PREORDER_KEY, JSON.stringify(preorderIds));
    debugLog('Saved to localStorage: ' + soldOutIds.length + ' sold-out, ' + preorderIds.length + ' preorder');
    applyToBuilder();

    try {
      var token = sessionStorage.getItem('admin_token');
      var body = { variantId: vidStr };

      if (action === 'sold-out') {
        body.soldOut = true;
        body.preorder = false;
      } else if (action === 'preorder') {
        body.preorder = true;
        body.soldOut = false;
      } else {
        body.soldOut = false;
        body.preorder = false;
      }

      var res = await fetch(SOLD_OUT_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (token || '') },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      debugLog('API POST response: ' + JSON.stringify(data));
      if (res.ok) {
        var msgs = {
          'sold-out': 'Saved — marked sold out',
          'preorder': 'Saved — marked preorder',
          'available': 'Saved — marked available'
        };
        showSaveToast(msgs[action] || 'Saved');
      } else {
        showSaveToast('API error: ' + (data.error || 'unknown'), true);
      }
    } catch(e) {
      debugLog('API save error: ' + e.message);
      showSaveToast('Saved locally — API offline', true);
    }
  }

  // ============================================================
  //  BUILDER SYNC
  // ============================================================
  function setupBuilderSync() {
    var builderPage = document.getElementById('page-builder');
    if (builderPage) {
      debugLog('Found #page-builder element');
      new MutationObserver(function() {
        if (builderPage.classList.contains('active')) {
          debugLog('Builder tab activated — applying states');
          applyToBuilder();
          setTimeout(applyToBuilder, 300);
          setTimeout(applyToBuilder, 800);
        }
      }).observe(builderPage, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('mousedown', function(e) {
      var target = e.target;
      if (target.tagName === 'OPTION' && target.getAttribute('data-sold-out') === 'true') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showBuilderToast('This item is sold out and cannot be selected.');
        return false;
      }
    }, true);

    document.addEventListener('change', function(e) {
      var dd = e.target;
      if (!dd.classList || !dd.classList.contains('component-dropdown')) return;
      var opt = dd.options[dd.selectedIndex];
      if (opt && opt.getAttribute('data-sold-out') === 'true') {
        e.stopImmediatePropagation();
        dd.value = '';
        showBuilderToast('This item is sold out.');
      }
    }, true);

    setInterval(function() {
      if (soldOutIds.length > 0 || preorderIds.length > 0) {
        applyToBuilder();
      }
    }, 2000);

    setTimeout(applyToBuilder, 500);
    setTimeout(applyToBuilder, 1500);
  }

  function applyToBuilder() {
    if (!soldOutIds.length && !preorderIds.length) return;

    var dropdownIds = [
      'caseDropdown', 'cpuDropdown', 'coolerDropdown', 'motherboardDropdown',
      'ramDropdown', 'gpuDropdown', 'psuDropdown', 'ssdDropdown', 'fanDropdown',
      'monitorDropdown', 'mouseDropdown', 'keyboardDropdown', 'headsetDropdown'
    ];

    var totalFound = 0;
    var totalSoldOut = 0;
    var totalPreorder = 0;

    dropdownIds.forEach(function(ddId) {
      var dropdown = document.getElementById(ddId);
      if (!dropdown) return;

      var options = dropdown.querySelectorAll('option');
      totalFound += options.length;

      options.forEach(function(opt) {
        if (!opt.value) return;
        var vidStr = String(opt.value);
        var isSO = soldOutIds.includes(vidStr);
        var isPO = preorderIds.includes(vidStr);

        // Clean up first
        opt.removeAttribute('data-sold-out');
        opt.removeAttribute('data-preorder');
        opt.textContent = opt.textContent.replace(/ — SOLD OUT/g, '').replace(/ — PREORDER/g, '');
        opt.style.color = '';
        opt.disabled = false;

        if (isSO) {
          totalSoldOut++;
          opt.setAttribute('data-sold-out', 'true');
          opt.textContent = opt.textContent + ' — SOLD OUT';
          opt.style.color = '#ef4444';
          opt.disabled = true;
        } else if (isPO) {
          totalPreorder++;
          opt.setAttribute('data-preorder', 'true');
          opt.textContent = opt.textContent + ' — PREORDER';
          opt.style.color = '#f59e0b';
          // Preorder items are NOT disabled — they can be selected
        }
      });

      // Deselect if currently selected item is sold out (NOT preorder)
      if (dropdown.value && soldOutIds.includes(String(dropdown.value))) {
        var selOpt = dropdown.querySelector('option[value="' + dropdown.value + '"]');
        var title = selOpt ? (selOpt.dataset.title || selOpt.textContent) : '';
        debugLog('Deselecting sold-out item from ' + ddId + ': ' + title);
        dropdown.value = '';
        dropdown.dispatchEvent(new Event('change', { bubbles: true }));

        var section = dropdown.closest('.accordion-section');
        if (section) {
          var body = section.querySelector('.accordion-body');
          if (body && !body.querySelector('.so-deselect-warn')) {
            var warn = document.createElement('div');
            warn.className = 'so-deselect-warn';
            warn.style.cssText = 'padding:0.75rem 1rem;border-radius:10px;font-size:0.95rem;font-weight:600;margin-bottom:0.85rem;background:rgba(239,68,68,0.1);border:1.5px solid rgba(239,68,68,0.25);color:#ef4444;display:flex;align-items:center;gap:0.5rem;';
            warn.innerHTML = '🚫 <span>"' + title.replace(/ — SOLD OUT$/, '') + '" was removed — marked as sold out by admin.</span>';
            body.insertBefore(warn, body.firstChild);
            setTimeout(function() { warn.remove(); }, 10000);
          }
        }
      }
    });

    // Mobile cards
    document.querySelectorAll('.m-product-card').forEach(function(card) {
      var btn = card.querySelector('.m-card-add-btn');
      if (!btn) return;
      var vid = btn.dataset.optValue;
      if (!vid) return;
      var vidStr = String(vid);
      var isSO = soldOutIds.includes(vidStr);
      var isPO = preorderIds.includes(vidStr);

      // Reset
      card.classList.remove('m-card-soldout', 'm-card-preorder');
      var existingOverlay = card.querySelector('.m-sold-out-overlay, .m-preorder-overlay');
      if (existingOverlay) existingOverlay.remove();

      if (isSO) {
        card.classList.add('m-card-soldout');
        var overlay = document.createElement('div');
        overlay.className = 'm-sold-out-overlay';
        overlay.innerHTML = '<span class="m-sold-out-text">SOLD OUT</span>';
        var wrap = card.querySelector('.m-card-image-wrap');
        if (wrap) wrap.appendChild(overlay);
        btn.disabled = true;
        btn.textContent = 'Sold Out';
        btn.style.opacity = '0.4';
        btn.style.cursor = 'not-allowed';
      } else if (isPO) {
        card.classList.add('m-card-preorder');
        var poOverlay = document.createElement('div');
        poOverlay.className = 'm-preorder-overlay';
        poOverlay.innerHTML = '<span class="m-preorder-text">PREORDER</span>';
        var poWrap = card.querySelector('.m-card-image-wrap');
        if (poWrap) poWrap.appendChild(poOverlay);
        // Preorder items stay enabled
        btn.disabled = false;
        btn.textContent = 'Preorder';
        btn.style.opacity = '1';
        btn.style.cursor = 'pointer';
      }
    });

    debugLog('Builder sync: ' + totalFound + ' options, ' + totalSoldOut + ' sold-out, ' + totalPreorder + ' preorder');
  }

  function showBuilderToast(msg) {
    var c = document.querySelector('.pc-builder-toast-container');
    if (!c) {
      c = document.createElement('div');
      c.className = 'pc-builder-toast-container';
      document.body.appendChild(c);
    }
    c.innerHTML = '';
    var t = document.createElement('div');
    t.className = 'pc-builder-toast toast-warn';
    t.innerHTML = '<span class="toast-icon">🚫</span><span class="toast-message">' + msg + '</span><button class="toast-close" type="button">✕</button>';
    t.querySelector('.toast-close').onclick = function() { t.remove(); };
    c.appendChild(t);
    t.offsetHeight;
    t.classList.add('toast-enter');
    setTimeout(function() { t.classList.add('toast-exit'); setTimeout(function() { t.remove(); }, 300); }, 3500);
  }

  // ============================================================
  //  ADMIN PRODUCT CARDS
  // ============================================================
  function applyAllStates() {
    document.querySelectorAll('.ap-card').forEach(function(card) {
      var vid = card.dataset.variantId;
      var isSO = soldOutIds.includes(vid);
      var isPO = preorderIds.includes(vid);
      var state = isSO ? 'sold-out' : isPO ? 'preorder' : 'available';
      applyCardState(card, state);
    });
    updateCount();
  }

  function applyCardState(card, state) {
    // state: 'available', 'preorder', 'sold-out'
    var vid = card.dataset.variantId;
    var badge = document.getElementById('badge-' + vid);
    var availBtn = card.querySelector('.ap-btn-available');
    var preorderBtn = card.querySelector('.ap-btn-preorder');
    var soldBtn = card.querySelector('.ap-btn-soldout');

    card.classList.remove('sold-out', 'preorder');

    if (availBtn) availBtn.classList.remove('active');
    if (preorderBtn) preorderBtn.classList.remove('active');
    if (soldBtn) soldBtn.classList.remove('active');

    if (state === 'sold-out') {
      card.classList.add('sold-out');
      if (badge) { badge.textContent = 'Sold Out'; badge.className = 'ap-stock-badge badge-soldout'; }
      if (soldBtn) soldBtn.classList.add('active');
    } else if (state === 'preorder') {
      card.classList.add('preorder');
      if (badge) { badge.textContent = 'Preorder'; badge.className = 'ap-stock-badge badge-preorder'; }
      if (preorderBtn) preorderBtn.classList.add('active');
    } else {
      if (badge) { badge.textContent = 'Available'; badge.className = 'ap-stock-badge'; }
      if (availBtn) availBtn.classList.add('active');
    }
  }

  function setupToggleButtons() {
    var grid = document.getElementById('apGrid');
    if (!grid) return;
    grid.addEventListener('click', function(e) {
      var btn = e.target.closest('.ap-btn');
      if (!btn) return;
      var vid = btn.dataset.variantId;
      var action = btn.dataset.action; // 'available', 'preorder', or 'sold-out'
      var card = btn.closest('.ap-card');
      if (!vid || !card) return;
      debugLog('Toggle: ' + vid + ' → ' + action);
      applyCardState(card, action);
      saveProductState(vid, action);
      filterCards();
    });
  }

  // ============================================================
  //  SEARCH + FILTERS
  // ============================================================
  function setupSearch() {
    var input = document.getElementById('apSearch');
    if (!input) return;
    var timer = null;
    input.addEventListener('input', function() {
      clearTimeout(timer);
      timer = setTimeout(function() { searchQuery = input.value.trim().toLowerCase(); filterCards(); }, 200);
    });
  }

  function setupCategoryFilter() {
    var c = document.getElementById('apFilterChips');
    if (!c) return;
    c.addEventListener('click', function(e) {
      var chip = e.target.closest('.ap-chip');
      if (!chip) return;
      c.querySelectorAll('.ap-chip').forEach(function(ch) { ch.classList.remove('active'); });
      chip.classList.add('active');
      activeCategory = chip.dataset.filter;
      filterCards();
    });
  }

  function setupStatusFilter() {
    document.querySelectorAll('.ap-status-chip').forEach(function(chip) {
      chip.addEventListener('click', function() {
        document.querySelectorAll('.ap-status-chip').forEach(function(ch) { ch.classList.remove('active'); });
        chip.classList.add('active');
        activeStatus = chip.dataset.status;
        filterCards();
      });
    });
  }

  function filterCards() {
    var cards = document.querySelectorAll('.ap-card');
    var visible = 0;
    cards.forEach(function(card) {
      var cat = card.dataset.category;
      var title = (card.dataset.title || '').toLowerCase();
      var isSO = card.classList.contains('sold-out');
      var isPO = card.classList.contains('preorder');
      var show = (activeCategory === 'all' || cat === activeCategory)
        && (!searchQuery || title.includes(searchQuery))
        && (activeStatus === 'all'
          || (activeStatus === 'available' && !isSO && !isPO)
          || (activeStatus === 'preorder' && isPO)
          || (activeStatus === 'sold-out' && isSO));
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    var empty = document.getElementById('apEmpty');
    if (empty) empty.style.display = visible === 0 ? 'flex' : 'none';
    updateCount(visible);
  }

  function updateCount(count) {
    var el = document.getElementById('apCount');
    if (!el) return;
    if (count === undefined) count = document.querySelectorAll('.ap-card:not([style*="display: none"])').length;
    var total = document.querySelectorAll('.ap-card').length;
    el.textContent = count + ' of ' + total + ' products (' + soldOutIds.length + ' sold out, ' + preorderIds.length + ' preorder)';
  }

  function showSaveToast(msg, isErr) {
    var old = document.querySelector('.ap-save-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'ap-save-toast' + (isErr ? ' error' : '');
    t.textContent = (isErr ? '⚠ ' : '✓ ') + msg;
    document.body.appendChild(t);
    requestAnimationFrame(function() { t.classList.add('show'); });
    setTimeout(function() { t.classList.remove('show'); setTimeout(function() { t.remove(); }, 400); }, 2500);
  }

  // ============================================================
  //  GLOBAL DEBUG
  // ============================================================
  window.EnotexSoldOut = {
    getIds: function() { return soldOutIds.slice(); },
    getPreorderIds: function() { return preorderIds.slice(); },
    isSoldOut: function(vid) { return soldOutIds.includes(String(vid)); },
    isPreorder: function(vid) { return preorderIds.includes(String(vid)); },
    refresh: applyToBuilder,
    debug: function() {
      console.log('=== SOLD OUT / PREORDER DEBUG ===');
      console.log('soldOutIds:', JSON.stringify(soldOutIds));
      console.log('preorderIds:', JSON.stringify(preorderIds));
      console.log('=== END DEBUG ===');
    }
  };

  console.log('%c🛒 ADMIN PRODUCTS v5 loaded — preorder support', 'color:#22c55e;font-size:13px;font-weight:bold;');
})();